import type { Theme } from "theme-ui";

import { buttons } from "./buttons.variants";
import { links } from "./links.variants";

export const theme: Theme = {
  space: [0, 4, 8, 12, 16, 32, 42, 64, 100, 128, 256, 360, 512],
  fonts: {
    body: '"Poppins", sans-serif',
    heading: '"Nunito", sans-serif',
  },
  fontSizes: [10, 12, 14, 16, 20, 24, 32, 46],
  fontWeights: { body: 400, heading: 700 },
  lineHeights: {
    body: 1.4,
    heading: 1.125,
  },
  colors: {
    text: "#19193E",
    background: "#F4FCFF",
    primary: "#19193E",
    primaryMedium: "#6F6F86",
    secondary: "#CC2F29",
    tertiary: "#98D945",
    accent: "#0D82DD",
    highlight: "#F5AA00",
    muted: "#f6f6f6",
    white: "#ffffff",
    grey: "#616D7B",
    greyMedium: "#D0D3D7",
  },
  sizes: [16, 32, 54, 86, 106],
  breakpoints: ["480px", "1000px", "1440px"],
  radii: [0, 5, 8, 12, 20],
  zIndices: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  shadows: [
    "0 10px 10px rgba(0,0,0,0.04)",
    "0px 10px 30px rgba(25, 25, 62, 0.1)",
    "0px 1px 2px rgba(97, 97, 97, 0.2), 0px 2px 4px rgba(97, 97, 97, 0.2)",
  ],
  // customs variants
  buttons,
  links,
};
